export const DEFAULT_CONFIG = {
  id: 'config/kurlyMallConfig.json',
  effects: {
    snow: false,
  },
};
